module.exports = __webpack_public_path__ + "img/img-avatar-06.7859a14b.png";